import React, { Component } from 'react';
import AuthStore from '../../Auth/AuthStore';
import Badge from '@mui/material/Badge';
import AddAlert from '@mui/icons-material/AddAlert';
import { createBrowserHistory } from 'history';
import { observer } from 'mobx-react';
import { HubConnectionBuilder } from '@aspnet/signalr';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';
import NotificationItem from './NotificationItem';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import SaleDoneDialog from '../Sales/SaleDoneDialog'
import SaleStore from '../Sales/SaleStore'
import MainStore from '../../../MainStore';
import './users.css'
import UserAvatar from './UserAvatar';
import ProjectDialog from '../Projects/ProjectDialog';
import SchedulleEditDialog from '../Scheduller/SchedulleEditDialog'
import { Button } from '@mui/material';

const history = createBrowserHistory();

const ProfileLink = observer(class ProfileLink extends Component {

    constructor(props) {
        super(props);

        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hub")
            .build();

        var scope = this;

        hubConnection.on('sendNotify', (recieverId, receivedMessage, id, workId) => {
            if (recieverId === AuthStore.getUserId) {
                var notification = scope.state.notification.slice(0);
                notification.push({ text: receivedMessage, id: id, workId: workId });
                scope.setState({ notification: notification, newNotify: receivedMessage, snackbarOpen: true });
            }
        });

        hubConnection.on('sendSaleDoneDialog', (recieverId, saleId, isProjectExist) => {
            if (recieverId === AuthStore.getUserId) {
                SaleStore.openSaleFinishDialog(saleId, isProjectExist);
            }
        });

        hubConnection.start();

        this.state = {
            hubConnection: hubConnection,
            notification: [],
            anchorEl: null,
            snackbarOpen: false,
            newNotify: ''
        };

        this.handleProfileClick = this.handleProfileClick.bind(this);
        this.handleBadgeClick = this.handleBadgeClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleNotifyDeleted = this.handleNotifyDeleted.bind(this);
        this.handleCleanNofiticationClick = this.handleCleanNofiticationClick.bind(this);
    }

    componentDidMount() {
        this.loadNotification();
    }

    componentDidUpdate(prevProps) {
    }

    loadNotification() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Notification', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                localStorage.setItem("token", null);
                AuthStore.setUserNonAuth();
                //AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ notification: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleProfileClick() {
        if (AuthStore.getIsPortal) return;
        history.push('/profile');
        window.location.replace('/profile');
    }

    handleBadgeClick(evt) {
        this.setState({ anchorEl: evt.currentTarget });
    }

    handleClose() {
        this.setState({ anchorEl: null });
    }

    handleNotifyDeleted(id) {
        var notification = this.state.notification.slice(0);
        notification.splice(notification.findIndex(n => n.id === id), 1);
        this.setState({ notification: notification });
    }

    handleCleanNofiticationClick() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Notification/DeleteAllNotification', {
            method: 'POST',
            body: null,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ notification: [], anchorEl: null });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        var notification = this.state.notification && this.state.notification.map(n => <NotificationItem id={n.id} key={n.id} workId={n.workId} onNotifyDeleted={this.handleNotifyDeleted}>{n.text}</NotificationItem>);

        return (
            <div>
                <div className="profile-link-icon" onClick={this.handleProfileClick}>
                    <UserAvatar userId={AuthStore.getUserId} />
                </div>
                <div className="profile-link-icon">
                    <Badge badgeContent={this.state.notification.length} onClick={this.handleBadgeClick} color="primary" invisible={this.state.notification.length === 0}>
                            <AddAlert />
                    </Badge>
                    <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >
                        <div style={{ "float": "right", "width": "100%" }} className="clean-notification-wrapper"><Button style={{ "float": "right" }} onClick={this.handleCleanNofiticationClick}>Очистить</Button></div>
                        {notification}
                    </Menu>
                </div>
                <SaleDoneDialog />
                <SchedulleEditDialog />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={MainStore.isSnackBarOpen}
                    autoHideDuration={7000}
                    onClose={() => { MainStore.closeSnackbar(); }}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{MainStore.getSnackBarText}</span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={() => { MainStore.closeSnackbar(); }}
                            size="large">
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
            </div>
        );
    }
})

export default ProfileLink;